// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1E3Du","col":"Table_col__2229H","fulfillmentStatus":"Table_fulfillmentStatus__2NMTT","emailCol":"Table_emailCol__3T4wm"};